import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "more-box__qty" };
var _hoisted_2 = { class: "filt-box__top" };
var _hoisted_3 = { class: "form-group" };
var _hoisted_4 = { class: "form-field form-field--text form-field--3 form-field--s form-field--primary" };
var _hoisted_5 = { class: "form-field__side form-field__side--left" };
var _hoisted_6 = ["placeholder"];
import { ref, watch } from 'vue';
import ItemWrapper from './ItemWrapper.vue';
import Icon from '../../../components/Icon.vue';
import Sprite from "../../../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextInputItem',
    props: {
        item: { type: Object, required: true },
    },
    emits: ["update"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var inputRef = ref(null);
        var textValue = ref(props.item.value || '');
        var isFocused = ref(false);
        var debounceTimer = null;
        function onInput() {
            var hasText = textValue.value.trim().length > 0;
            props.item.value = textValue.value;
            props.item.active = textValue.value.trim().length > 0;
            props.item.count = hasText ? 1 : 0;
            if (debounceTimer)
                clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
                emit('update', true);
            }, 350);
        }
        function onBlur() {
            isFocused.value = false;
            props.item.value = textValue.value;
            props.item.active = textValue.value.trim().length > 0;
        }
        function reset() {
            var _a;
            textValue.value = '';
            props.item.value = '';
            props.item.active = false;
            props.item.count = 0;
            isFocused.value = false;
            if (debounceTimer)
                clearTimeout(debounceTimer);
            emit('update', false);
            (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // Синхронизируем значение из стора ТОЛЬКО если пользователь прямо сейчас не печатает в поле
        watch(function () { return props.item.value; }, function (val) {
            if (!isFocused.value) {
                textValue.value = val || '';
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(ItemWrapper, {
                item: __props.item,
                noResetButton: "",
                onReset: reset
            }, _createSlots({
                body: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(Icon, {
                                        name: "search",
                                        "class-name": "form-icon"
                                    })
                                ]),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                _withDirectives(_createElementVNode("input", {
                                    ref_key: "inputRef",
                                    ref: inputRef,
                                    type: "text",
                                    class: "form-control",
                                    placeholder: __props.item.placeholder,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((textValue).value = $event); }),
                                    onInput: onInput,
                                    onFocus: _cache[1] || (_cache[1] = function ($event) { return (isFocused.value = true); }),
                                    onBlur: onBlur
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
                                    [_vModelText, textValue.value]
                                ]),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                (textValue.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn--4 btn--m btn--gray btn--icon",
                                        onMousedown: _cache[2] || (_cache[2] = _withModifiers(function () { }, ["prevent"])),
                                        onClick: reset
                                    }, [
                                        _createVNode(Sprite, { name: "cross" })
                                    ], 32 /* NEED_HYDRATION */))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ]; }),
                _: 2 /* DYNAMIC */
            }, [
                (__props.item.active)
                    ? {
                        name: "badge",
                        fn: _withCtx(function () { return [
                            _createElementVNode("span", _hoisted_1, _toDisplayString(__props.item.count), 1 /* TEXT */)
                        ]; }),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["item"]));
        };
    }
});
